import CardView from './CardView'

export default CardView
